import { Events } from 'src/constants/webSocketConsts/events';
import {
  AIAssistantStatus,
  clearStatus,
  setStatus,
} from 'src/store/aiAssistantStatus/slice';
import { AppDispatch } from 'src/store/configureStore';

interface AIStatusUpdate {
  fields?: {
    channelId?: string;
    status?: string;
    metadata?: {
      tool?: string;
      query?: string;
      errorMessage?: string;
      errorType?: string;
    };
  };
}

const isValidAIAssistantStatus = (
  status: string,
): status is AIAssistantStatus => {
  const validStatuses: Set<string> = new Set([
    'sending',
    'thinking',
    'searching_web',
    'generating_response',
    'using_tools',
    'get_client_context',
    'get_company_context',
    'get_workspace_context',
    'taking_longer',
    'error',
  ]);
  return validStatuses.has(status);
};

export const aiAssistantStatusHandler = (
  _event: Events,
  items: AIStatusUpdate[],
  dispatch: AppDispatch,
): void => {
  items.forEach((item) => {
    // Extract data from fields object (consistent with other WebSocket handlers)
    const channelId = item.fields?.channelId;
    const status = item.fields?.status;
    const metadata = item.fields?.metadata;

    if (!channelId) {
      console.warn('AI Assistant Status: No channelId found in item:', item);
      return;
    }

    if (status !== undefined) {
      // Empty string means explicitly clear the status
      if (status === '') {
        dispatch(clearStatus({ channelId }));
        return;
      }

      if (!isValidAIAssistantStatus(status)) {
        console.warn(
          'AI Assistant Status: Invalid status value received:',
          status,
        );
        // Fallback to a generic status to avoid gaps in status display
        dispatch(
          setStatus({
            channelId,
            status: 'thinking',
            metadata: undefined,
          }),
        );
        return;
      }

      dispatch(
        setStatus({
          channelId,
          status,
          metadata,
        }),
      );
    }
    // If status is undefined (not present in the message), don't change anything
    // This prevents accidental clears from unrelated WebSocket messages
  });
};
